
function MarketRealTime({ config, row }) {

    const renderColumn = config.map((column) => {
        return (
            <th className="text-center" key={column.key}>{column.value}</th>
        )
    })

    const rendererFunction = (row, column, stockField) => {
        let value, className;
        if (stockField === 'stock_rights') {
            value = column.rendererStockRight ? column.rendererStockRight(row) : column.renderer(row, 'stock_rights')
            className = column.rendererClassStockRight ? column.rendererClassStockRight(row) : column.classes ? column.classes(row) : ''
        }
        else if (stockField === 'stock_rights_fund') {
            value = column.rendererStockRightFund ? column.rendererStockRightFund(row) : column.renderer(row, 'stock_rights_fund')
            className = column.rendererClassStockRightFund ? column.rendererClassStockRightFund(row) : column.classes ? column.classes(row) : ''
        } else if (stockField === 'fund_fixed') {
            value = column.rendererFundFixed ? column.rendererFundFixed(row) : column.renderer(row, 'fund_fixed')
            className = column.rendererClassFundFixed ? column.rendererClassFundFixed(row) : column.classes ? column.classes(row) : ''
        }

        return [value, className]
    }

    // const renderedCells = (stockField) => {
    //     return config.map((column) => {
    //         const [value, className] = rendererFunction(row, column, stockField)
    //         const classNames = className ? className + ' px-2 py-5 bg-white' : 'px-2 py-5 bg-white'
    //         return (
    //             <td className={classNames} key={column.key} style={{ direction: 'ltr' }} >
    //                 {value}
    //             </td>
    //         );
    //     });
    // }

    const renderedCells = (stockField) => {
        return config.map((column) => {
            const classNames = column.className ? column.className(row, stockField) + ' px-2 py-5 bg-white' : 'px-2 py-5 bg-white'
            return (
                <td className={classNames} key={column.key} style={{ direction: 'ltr' }} >
                    {column.renderer(row, stockField)}
                </td>
            );
        });
    }

    return (
        <div className="table-responsive">
            <div className="mb-20">
                <div className="d-flex justify-content-between">
                    <h2 className="font-bold mb-3">سهام و حق تقدم</h2>
                    <h2 className="font-bold mb-3" style={{ direction: 'ltr' }}>{row.date} - {row.time}</h2>
                </div>
                <table className="table table-bordered table-rounded">
                    <thead className="bg-blue">
                        <tr className="fw-semibold fs-6 border-bottom-2 mb-5 border-gray-200">{renderColumn}</tr>
                    </thead>

                    <tbody className="">
                        <tr className="text-center">
                            {renderedCells('stock_rights')}
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="mb-20">
                <h2 className="font-bold mb-3">سهام و حق تقدم و صندوق های سهامی</h2>
                <table className="table table-bordered table-rounded">
                    <thead className="bg-blue">
                        <tr className="fw-semibold fs-6 border-bottom-2 mb-5 border-gray-200">{renderColumn}</tr>
                    </thead>

                    <tbody className="">
                        <tr className="text-center">
                            {renderedCells('stock_rights_fund')}
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="mb-20">
                <h2 className="font-bold mb-3">صندوق درآمدثابت</h2>
                <table className="table table-bordered table-rounded">
                    <thead className="bg-blue">
                        <tr className="fw-semibold fs-6 border-bottom-2 mb-5 border-gray-200">{renderColumn}</tr>
                    </thead>

                    <tbody className="">
                        <tr className="text-center">
                            {renderedCells('fund_fixed')}
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )

}

export default MarketRealTime